import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import MPHButton from "../MPHButtons/MPHButton";
import MPHCheckbox from "src/components/DataProviders/MPHCheckBox";
import { useApiAxiosRequests } from "src/utils/ApiService/MPHApis";
import { useStorage } from "src/utils/storage";
import { errorToast, successToast } from "src/utils/toast";
import moment from "moment";

const MPHOptIn = (isLogIn: any) => {
  const navigate = useNavigate();
  const { issuePromotion, promotionBE } = useApiAxiosRequests();
  const storage = useStorage();
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState('0');

  const handleOptIn = async () => {
    setIsLoading(true);
    const userProfile = await storage.get('user_profile') || '';
    const parsedData = JSON.parse(userProfile);
    const email = parsedData?.email;

    const body = {
      "programId": 1148,
      "promotionId": 37437
    }

    const bePayload = {
      "Promotion_id": 37437,
      "Source_Channel": "Web",
      "acquisition_channel": "mpmwebsite", //added the value
      "date": moment().format("MM-DD-YYYY"),
      "email": email,
      "event_name": "Opt_Sweepstakes"
    }

    const res: any = await issuePromotion(email, body);
    if (res?.data?.sideEffects.length > 0) {
      const beRes: any = await promotionBE(bePayload);
      setIsLoading(false);
      if (beRes?.data?.status?.code == '1100') {
        successToast("Success! You’re registered");
        navigate("/find-hotels");
      } else {
        errorToast("OptIn Failed");
      }

    } else {
      setIsLoading(false);
      errorToast("Customer already opted in or is unable to opt in");
      navigate("/find-hotels");
    }
  }

  return (<>
    <div className="modal-content form-modal-complete">
      <label className="form-label">My Place Memories</label>

      <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12 mt-1 mb-3">
        <MPHCheckbox
          label={"Register me for the My Place Memories Sweepstakes"}
          key={"email"}
          id={"email"}
          isModal={true}
          value={
            isChecked === "0"
              ? false
              : true
          }
          onChangeText={(text: any) => {
            text == true ? setIsChecked('1') : setIsChecked('0')
          }}
        />
      </div>
      <div className="col-xl-6 col-lg-6 col-sm-12 col-md-12 mt-5">
        <MPHButton
          buttonText="Submit"
          disabled={isLoading || isChecked == '0'}
          isLoading={isLoading}
          onbuttonClick={() => handleOptIn()}
        />
      </div>
    </div>
  </>)

}

export default MPHOptIn